/* Novo components. Written for this theme; sits on top of Dawn. */
(() => {
  const NH = (window.NH = window.NH || {});

  /* ---------- Money ---------- */
  NH.formatMoney = (cents, format) => {
    const fmt = format || NH.moneyFormat || '${{amount}}';
    const value = Number(cents) || 0;
    const group = (num, decimals, thousands, decimal) => {
      const fixed = (num / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + decimal + frac : withSep;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return group(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return group(value, 2, "'", '.');
        case 'amount_with_space_separator':
          return group(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return group(value, 0, ' ', ',');
        default:
          return group(value, 2, ',', '.');
      }
    });
  };

  const define = (name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  };

  /* ---------- Deal picker ---------- */
  class NhOffers extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.inputs = Array.from(this.querySelectorAll('.nh-offer__input'));
      this.qtyInput = this.querySelector('[data-nh-qty]');
      this.subscribed = !!document.querySelector(
        `nh-subscribe[data-form-id="${this.formId}"] .nh-sub__input:checked`
      );

      this.addEventListener('change', (e) => {
        if (e.target.classList.contains('nh-offer__input')) this.select(e.target);
      });

      this.onSubscribe = (e) => {
        if (e.detail.formId !== this.formId) return;
        this.subscribed = e.detail.on;
        this.renderPrices();
        this.announce();
      };
      document.addEventListener('nh:subscribe', this.onSubscribe);

      const isAvailable = (i) => i.dataset.available === 'true';
      const checked = this.inputs.find((i) => i.checked);
      const start = (checked && isAvailable(checked) ? checked : this.inputs.find(isAvailable)) || checked || this.inputs[0];
      if (start) {
        start.checked = true;
        this.select(start);
      }
      this.renderPrices();
    }

    disconnectedCallback() {
      document.removeEventListener('nh:subscribe', this.onSubscribe);
    }

    get form() {
      return document.getElementById(this.formId);
    }

    get selected() {
      return this.inputs.find((i) => i.checked);
    }

    select(input) {
      this.inputs.forEach((i) => i.closest('.nh-offer').classList.toggle('is-selected', i === input));

      const form = this.form;
      const idInput = form && form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = input.dataset.variantId;
        idInput.disabled = false;
      }
      if (this.qtyInput) this.qtyInput.value = input.dataset.quantity;

      const available = input.dataset.available === 'true';
      customElements.whenDefined('product-form').then(() => {
        const productForm = form && form.closest('product-form');
        if (productForm && typeof productForm.toggleSubmitButton === 'function') {
          productForm.toggleSubmitButton(!available, window.variantStrings && window.variantStrings.soldOut);
          if (available) productForm.handleErrorMessage && productForm.handleErrorMessage();
        }
      });

      this.announce();
    }

    announce() {
      const input = this.selected;
      if (!input) return;
      document.dispatchEvent(
        new CustomEvent('nh:offer-change', {
          detail: {
            formId: this.formId,
            variantId: input.dataset.variantId,
            quantity: Number(input.dataset.quantity),
            price: this.priceFor(input),
            inventory: input.dataset.inventory === '' ? null : Number(input.dataset.inventory),
            hasPlan: input.dataset.subPrice !== '',
          },
        })
      );
    }

    priceFor(input) {
      const sub = input.dataset.subPrice;
      return this.subscribed && sub !== '' ? Number(sub) : Number(input.dataset.price);
    }

    renderPrices() {
      const saveLabel = this.dataset.saveLabel || '';
      const caption = this.dataset.caption || '';
      const hideZero = this.dataset.hideZero === 'true';
      this.inputs.forEach((input) => {
        const card = input.closest('.nh-offer');
        const price = this.priceFor(input);
        const compare = Number(input.dataset.compare) || 0;
        const days = Math.max(1, Number(input.dataset.days) || 30);
        const save = Math.max(0, compare - price);

        const priceEl = card.querySelector('[data-nh-price]');
        if (priceEl) priceEl.textContent = NH.formatMoney(price);

        const compareEl = card.querySelector('[data-nh-compare]');
        if (compareEl) {
          compareEl.textContent = NH.formatMoney(compare);
          compareEl.hidden = !(compare > price);
        }

        const saveEl = card.querySelector('[data-nh-save]');
        if (saveEl) {
          saveEl.textContent = saveLabel.replace('[amount]', NH.formatMoney(save));
          saveEl.hidden = hideZero && save === 0;
        }

        const captionEl = card.querySelector('[data-nh-caption]');
        if (captionEl) {
          captionEl.textContent = caption
            .replace('[days]', String(days))
            .replace('[per_day]', NH.formatMoney(Math.floor(price / days)));
        }
      });
    }
  }

  /* ---------- Subscribe & save ---------- */
  class NhSubscribe extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('.nh-sub__input');
      this.plan = this.querySelector('input[name="selling_plan"]');
      this.hasPlan = true;
      if (!this.box) return;
      this.box.addEventListener('change', () => this.update());
      this.onOffer = (e) => {
        if (e.detail.formId !== this.dataset.formId) return;
        this.hasPlan = e.detail.hasPlan;
        this.syncPlan();
      };
      document.addEventListener('nh:offer-change', this.onOffer);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('nh:offer-change', this.onOffer);
    }

    syncPlan() {
      if (this.plan) this.plan.disabled = !(this.box.checked && this.hasPlan);
    }

    update() {
      this.classList.toggle('is-checked', this.box.checked);
      this.syncPlan();
      document.dispatchEvent(
        new CustomEvent('nh:subscribe', { detail: { formId: this.dataset.formId, on: this.box.checked } })
      );
    }
  }

  /* ---------- Stock pill ---------- */
  class NhStock extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) || 0;
      this.countEl = this.querySelector('[data-nh-count]');
      this.onOffer = (e) => {
        if (e.detail.formId !== this.dataset.formId) return;
        const n = e.detail.inventory;
        if (this.dataset.mode === 'always') {
          if (this.countEl && n !== null) this.countEl.textContent = n;
          return;
        }
        if (n === null || n <= 0 || n > this.threshold) {
          this.hidden = true;
          return;
        }
        if (this.countEl) this.countEl.textContent = n;
        this.hidden = false;
      };
      document.addEventListener('nh:offer-change', this.onOffer);
    }

    disconnectedCallback() {
      document.removeEventListener('nh:offer-change', this.onOffer);
    }
  }
  // Listeners first, so they hear the deal picker's first announcement.
  define('nh-stock', NhStock);
  define('nh-subscribe', NhSubscribe);
  define('nh-offers', NhOffers);

  /* ---------- Countdown ---------- */
  class NhCountdown extends HTMLElement {
    connectedCallback() {
      this.end = this.parseEnd(this.dataset.end, this.dataset.tz);
      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => (this.nums[el.dataset.unit] = el));
      if (this.end === null) {
        this.hidden = true;
        return;
      }
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    parseEnd(raw, tz) {
      const m = String(raw || '')
        .trim()
        .match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return null;
      const t = String(tz || '+0000').match(/^([+-])(\d{2}):?(\d{2})$/);
      const offset = t ? (t[1] === '-' ? -1 : 1) * (Number(t[2]) * 60 + Number(t[3])) : 0;
      const hour = m[4] === undefined ? 23 : Number(m[4]);
      const minute = m[5] === undefined ? 59 : Number(m[5]);
      const second = m[4] === undefined ? 59 : 0;
      return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), hour, minute, second) - offset * 60000;
    }

    tick() {
      let left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const d = Math.floor(left / 86400);
      left -= d * 86400;
      const h = Math.floor(left / 3600);
      left -= h * 3600;
      const m = Math.floor(left / 60);
      const s = left - m * 60;
      const pad = (n) => String(n).padStart(2, '0');
      if (this.nums.d) this.nums.d.textContent = pad(d);
      if (this.nums.h) this.nums.h.textContent = pad(h);
      if (this.nums.m) this.nums.m.textContent = pad(m);
      if (this.nums.s) this.nums.s.textContent = pad(s);

      if (this.end - Date.now() <= 0) {
        clearInterval(this.timer);
        if (window.Shopify && Shopify.designMode) return;
        if (this.dataset.onEnd === 'hide_timer') {
          this.hidden = true;
        } else {
          const bar = this.closest('[data-nh-cdbar]');
          if (bar) bar.hidden = true;
        }
      }
    }
  }
  define('nh-countdown', NhCountdown);

  /* ---------- Reviews slider ---------- */
  class NhSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.track || this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.fade = this.dataset.mode === 'fade';
      this.index = 0;

      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => {
          this.go(Number(dot.dataset.dot));
          this.restart();
        })
      );
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });

      if (this.fade) {
        let x0 = null;
        this.track.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        this.track.addEventListener(
          'touchend',
          (e) => {
            if (x0 === null) return;
            const dx = e.changedTouches[0].clientX - x0;
            if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
            x0 = null;
          },
          { passive: true }
        );
      } else {
        this.track.addEventListener(
          'scroll',
          () => {
            const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
            if (i !== this.index) this.setActive(i);
          },
          { passive: true }
        );
      }

      this.delay = Number(this.dataset.autoplay) || 0;
      if (this.delay > 0) {
        this.paused = false;
        ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
          this.addEventListener(ev, () => (this.paused = true), { passive: true })
        );
        ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => (this.paused = false)));
        this.restart();
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    restart() {
      if (!this.delay) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.paused || document.hidden) return;
        this.go(this.index + 1);
      }, this.delay * 1000);
    }

    go(i) {
      const n = this.slides.length;
      const to = ((i % n) + n) % n;
      if (!this.fade) this.track.scrollTo({ left: to * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(to);
    }

    setActive(i) {
      this.index = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }
  }
  define('nh-slider', NhSlider);

  /* ---------- Sticky add to cart ---------- */
  class NhStickyAtc extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.nh-sticky__btn');
      this.priceEl = this.querySelector('.nh-sticky__price');
      this.watch = document.querySelector('product-info .product-form__buttons') || document.querySelector('product-info');
      if (!this.watch) return;

      // A scroll check, not an IntersectionObserver: a fast fling or a jump link can carry the
      // buttons from below the screen to above it without them ever intersecting.
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.toggle(this.watch.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();

      this.button.addEventListener('click', () => this.act());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    toggle(show) {
      if (show === this.shown) return;
      this.shown = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.button.tabIndex = show ? 0 : -1;
      document.documentElement.style.setProperty('--nh-sticky-h', show ? `${this.offsetHeight}px` : '0px');
    }

    act() {
      // The deal picker: the theme's own, or a bundle app's widget (Kaching) inside the product info.
      const offers = Array.from(
        document.querySelectorAll('product-info nh-offers, product-info [class*="kaching"], product-info [id*="kaching"]')
      ).find((el) => el.offsetHeight > 0);
      if (this.dataset.action === 'add') {
        const form = document.querySelector('product-info product-form form');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          return;
        }
      }
      const target = offers || this.watch;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusable = target.querySelector('.nh-offer__input:checked') || target.querySelector('button, input');
      if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 600);
    }
  }
  define('nh-sticky-atc', NhStickyAtc);

  /* ---------- Results rings ---------- */
  class NhResults extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('nh-results--animate') || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      this.classList.add('is-pending');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            requestAnimationFrame(() => this.classList.remove('is-pending'));
            this.observer.disconnect();
          }
        },
        { threshold: 0.35 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  define('nh-results', NhResults);

  /* ---------- Back to top ---------- */
  class NhBackToTop extends HTMLElement {
    connectedCallback() {
      this.querySelector('button').addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
      const after = Number(this.dataset.after) || 400;
      this.onScroll = () => (this.hidden = window.scrollY < after);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  define('nh-back-to-top', NhBackToTop);

  /* ---------- Cart reservation timer ---------- */
  // Counts down from the set minutes, starting when the shopper first sees it; starts again when it runs out.
  class NhCartTimer extends HTMLElement {
    connectedCallback() {
      this.out = this.querySelector('[data-nh-time]');
      this.duration = Math.max(1, Number(this.dataset.minutes) || 5) * 60000;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    start() {
      let t = NhCartTimer.memory || null;
      try {
        const v = Number(sessionStorage.getItem('nhCartTimerStart'));
        if (v) t = v;
      } catch (e) {}
      const now = Date.now();
      if (!t || now - t >= this.duration || t > now) {
        t = now;
        try {
          sessionStorage.setItem('nhCartTimerStart', String(t));
        } catch (e) {}
      }
      NhCartTimer.memory = t;
      return t;
    }

    tick() {
      const left = Math.max(0, this.duration - (Date.now() - this.start()));
      const m = Math.floor(left / 60000);
      const s = Math.floor((left % 60000) / 1000);
      if (this.out) this.out.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
  }
  define('nh-cart-timer', NhCartTimer);

  /* ---------- Rotating messages (one at a time on mobile) ---------- */
  class NhRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.nh-ticker__item'));
      if (this.items.length < 2) return;
      this.index = Math.max(0, this.items.findIndex((i) => i.classList.contains('is-active')));
      this.mobile = window.matchMedia('(max-width: 749px)');
      const delay = Math.max(2, Number(this.dataset.speed) || 3) * 1000;
      this.timer = setInterval(() => {
        if (!this.mobile.matches || document.hidden || this.paused) return;
        this.show((this.index + 1) % this.items.length);
      }, delay);
      this.addEventListener('pointerenter', () => (this.paused = true));
      this.addEventListener('pointerleave', () => (this.paused = false));
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.items.indexOf(e.target);
        if (i > -1) {
          this.paused = true;
          this.show(i);
        }
      });
      this.addEventListener('shopify:block:deselect', () => (this.paused = false));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    show(i) {
      this.items[this.index].classList.remove('is-active');
      this.index = i;
      this.items[i].classList.add('is-active');
    }
  }
  define('nh-rotator', NhRotator);

  /* ---------- Order tracking (17TRACK widget) ---------- */
  class NhTrackOrder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.error = this.querySelector('.nh-track__error');
      this.result = this.querySelector('.nh-track__result');
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.track();
      });
    }

    loadWidget() {
      if (window.YQV5) return Promise.resolve();
      if (!NhTrackOrder.loading) {
        NhTrackOrder.loading = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://www.17track.net/externalcall.js';
          s.async = true;
          s.onload = () => (window.YQV5 ? resolve() : reject(new Error('17TRACK unavailable')));
          s.onerror = () => reject(new Error('17TRACK unavailable'));
          document.head.appendChild(s);
        });
      }
      return NhTrackOrder.loading;
    }

    track() {
      const num = this.input.value.trim();
      this.error.hidden = num !== '';
      if (!num) {
        this.input.focus();
        return;
      }
      this.loadWidget()
        .then(() => {
          window.YQV5.trackSingle({
            YQ_ContainerId: this.result.id,
            YQ_Height: 560,
            YQ_Fc: '0',
            YQ_Lang: this.dataset.lang || 'en',
            YQ_Num: num,
          });
        })
        .catch(() => {
          window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
        });
    }
  }
  define('nh-track-order', NhTrackOrder);

  /* ---------- Product gallery dots (mobile, arrows-on-image style) ---------- */
  const initGalleryDots = (root) => {
    root.querySelectorAll('[data-nh-gallery="overlay"] slider-component').forEach((slider) => {
      if (slider.querySelector('.nh-gallery-dots')) return;
      const build = () => {
        const total = slider.totalPages || 0;
        let wrap = slider.querySelector('.nh-gallery-dots');
        if (total < 2) {
          if (wrap) wrap.remove();
          return;
        }
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'nh-gallery-dots';
          slider.appendChild(wrap);
        }
        if (wrap.children.length !== total) {
          wrap.innerHTML = '';
          for (let i = 0; i < total; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'nh-dot';
            dot.setAttribute('aria-label', `${i + 1} / ${total}`);
            dot.addEventListener('click', () =>
              slider.slider.scrollTo({ left: i * (slider.sliderItemOffset || slider.slider.clientWidth), behavior: 'smooth' })
            );
            wrap.appendChild(dot);
          }
        }
        Array.from(wrap.children).forEach((d, i) => d.classList.toggle('is-active', i === (slider.currentPage || 1) - 1));
      };
      slider.addEventListener('slideChanged', build);
      new ResizeObserver(() => build()).observe(slider);
      build();
    });
  };

  const ready = () =>
    customElements.whenDefined('slider-component').then(() => initGalleryDots(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  document.addEventListener('shopify:section:load', (e) => initGalleryDots(e.target));

  /* ---------- "ID of the section to scroll to" (rating line, trust pill) ---------- */
  const scrollTarget = (id) => {
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.querySelector(`[id$="__${CSS.escape(id)}"]`) ||
      document.querySelector(`[id*="${CSS.escape(id)}"]`)
    );
  };
  const onScrollTrigger = (e) => {
    const el = e.target.closest('[data-nh-scroll]');
    if (!el || e.target.closest('a')) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    const target = scrollTarget(el.dataset.nhScroll);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  document.addEventListener('click', onScrollTrigger);
  document.addEventListener('keydown', onScrollTrigger);

  /* ---------- Buy buttons: price inside the button, Skip cart, secondary Buy It Now ---------- */
  NH.skipCart = false;
  const buyBlocks = () => Array.from(document.querySelectorAll('.nh-buy'));
  document.addEventListener('nh:offer-change', (e) => {
    const d = e.detail || {};
    buyBlocks().forEach((b) => {
      const form = b.querySelector('form[id]');
      const el = b.querySelector('[data-nh-btn-price]');
      if (el && form && form.getAttribute('id') === d.formId && typeof d.price === 'number') el.textContent = NH.formatMoney(d.price);
    });
  });
  document.querySelectorAll('nh-offers').forEach((o) => typeof o.announce === 'function' && o.announce());
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const v = event && event.data && event.data.variant;
      if (!v) return;
      buyBlocks().forEach((b) => {
        const el = b.querySelector('[data-nh-btn-price]');
        if (el && !document.querySelector('nh-offers')) el.textContent = NH.formatMoney(v.price);
      });
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!NH.skipCart || !event || event.source !== 'product-form') return;
      NH.skipCart = false;
      window.location.href = '/checkout';
    });
  }
  document.addEventListener(
    'click',
    (e) => {
      const buyNow = e.target.closest('[data-nh-buy-now]');
      const main = e.target.closest('.nh-buy[data-nh-skip-cart] .product-form__submit');
      if (!buyNow && !main) return;
      NH.skipCart = true;
      if (buyNow) {
        const btn = buyNow.closest('.nh-buy').querySelector('.product-form__submit');
        if (btn && !btn.disabled) btn.click();
      }
    },
    true
  );
})();
